import { LiaTransparentElement } from '@liasoft/lit-ui';
import { html } from 'lit';

/**
 * The catch-all.
 *
 * It names the path that missed rather than only saying "not found": every address here is meant to be
 * shareable, so the useful thing to show somebody who followed a broken link is the link they followed.
 */
export class AppNotFound extends LiaTransparentElement
{
   render()
   {
      return html`
         <lia-page title="Not found" icon="fa-solid fa-circle-question">
            <lia-empty-state
               centered
               icon="fa-solid fa-map-location-dot"
               title="No such page"
               message=${location.pathname}
               .actions=${[{
                  id: 'home',
                  label: 'Back to the dashboard',
                  icon: 'fa-solid fa-gauge-high',
                  variant: 'primary',
                  href: '/dashboard'
               }]}
            ></lia-empty-state>
         </lia-page>`;
   }
}

customElements.define('app-not-found', AppNotFound);
